// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__WDTHP","title":"styles_title__VWV2P"};